import { render } from "./AuthenticatedLayout.vue?vue&type=template&id=2fcb1b78&scoped=true"
import script from "./AuthenticatedLayout.vue?vue&type=script&lang=js"
export * from "./AuthenticatedLayout.vue?vue&type=script&lang=js"

import "./AuthenticatedLayout.vue?vue&type=style&index=0&id=2fcb1b78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fcb1b78"]])

export default __exports__